<template>
    <article 
        component-name="wrapper-blocks" 
        class="flex flex-col items-stretch w-full gap-5xl"
    >
        <!-- COMPOSER -->
        <div v-if="data?.composer" class="contents">
            <component  
                v-for="(block, index) in data.composer" 
                :key="index" 
                :is="`${index > 2 ? 'lazy-' : ''}${block.is}`" 
                :loading="index > 2 ? 'lazy' : 'auto'" 
                :config="block.config"
                :data="block.data"
                :use-component-name="route.name === 'locale-demo-components'"
            />
        </div>
        <!-- end COMPOSER -->

        <!-- DECLARATIVE MARKUP -->
        <slot v-else :data="data" />
        <!-- end DECLARATIVE MARKUP -->
    </article>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: false,
  },
});
const route = useRoute();
</script>